module.exports = __webpack_public_path__ + "c6872dbb97c8098b4439a6be5b154181.png";